// Constants
import { FOOTER_PAYMENTS } from "constants/partners";

import "./styles.sass";

const FooterPaymentsList = () => {
  return (
    <div className="FooterPaymentsList">
      {FOOTER_PAYMENTS.map((payment) => (
        <div className="FooterPaymentsList__logo" key={payment.id}>
          {payment.icon}
        </div>
      ))}
    </div>
  );
};

export default FooterPaymentsList;
